<template>
  <div class="overflow-hidden h-100 w-100 font_Montserrat">
    <div
      class="v3_color_teal font_size_1125rem font-weight-bold v2_font_Montserrat my-0 border_bottom_1 border_bottom_light_teal"
    >
      <span>Core ICO Terms</span>
  </div>
    <div class="d-flex flex-column justify-content-stretch mt-3">
      <job-profile-preference-job-question
        v-for="jq in jobQuestions"
        :key="jq.id"
        :job-question="jq"
        :is-selected="jq.id === editedQuestionId"
        @select-question="$emit('select-question', $event)"
      />
    </div>

    <template v-if="hasOptionalQuestions">
      <div
        class="v3_color_teal font_size_1125rem font-weight-bold v2_font_Montserrat my-0 border_bottom_1 border_bottom_light_teal"
      >
        <span>Additional ICO Terms</span>
    </div>
      <job-profile-preference-job-question
        v-for="jq in optionalQuestions"
        :key="jq.id"
        :job-question="jq"
        :is-selected="jq.id === editedQuestionId"
        @select-question="$emit('select-question', $event)"
      />
    </template>
  </div>
</template>

<script>
import JobProfilePreferenceJobQuestion from '@/components/exchange/preference-list/JobProfilePreferenceJobQuestion';

export default {
  name: 'JobProfilePreferences',
  components: { JobProfilePreferenceJobQuestion },
  props: {
    jobQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedOptionalQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    optionalQuestions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    editedQuestionId: Number,
  },
  computed: {
    hasOptionalQuestions: function () {
      return !!this.optionalQuestions.length;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../../sass/variables_mixins';
.job-profile-preferences {
  @media (min-width: 991px) {
    position: sticky;
    top: 125px;
    z-index: 1;
    max-height: calc(100vh - 100px);
    overflow: auto;
    overflow-x: hidden;
    margin-bottom: 13px;
  }
}
</style>
